import React from 'react';
import { compose, prop, not, always } from 'ramda';
import { branch, renderComponent } from 'recompose';

import connect from 'app/libs/connect';
import withDispatchOnMount from 'app/enhancers/withDispatchOnMount';
import { handleSubscriptionTrackEvents } from 'app/features/success/actions';
import { LENGTH_OF_COUPON_FREE_TRIAL } from 'app/constants/freeTrial';
import { isUserPremium } from 'app/features/user/selectors';
import HomeRedirect from 'app/router/HomeRedirect';
import StackedLayout from 'app/components/layout/StackedLayout';
import MetaTitle from 'app/features/success/components/MetaTitle';
import HeroBlock from 'app/features/couponCampaign/success/components/HeroBlock';
import SeriesBlock from 'app/features/success/seriesBlock/components/SeriesBlock';
import OfflineViewingBlock from 'app/features/success/offlineViewingBlock/components/OfflineViewingBlock';
import LatestNewsBlock from 'app/features/couponCampaign/success/components/LatestNewsBlock';
import MangaBlock from 'app/features/couponCampaign/success/components/MangaBlock';
import HelpCenterBlock from 'app/features/couponCampaign/success/components/HelpCenterBlock';

const UI = () => (
  <StackedLayout hasMarginTop>
    <MetaTitle />
    <HeroBlock />
    <SeriesBlock />
    <OfflineViewingBlock />
    <LatestNewsBlock />
    <MangaBlock />
    <HelpCenterBlock />
  </StackedLayout>
);

UI.displayName = 'CouponCampaign Success';

const CouponCampaignSuccess = compose(
  connect({ isUserPremium }),
  branch(compose(not, prop('isUserPremium')), renderComponent(HomeRedirect)),
  withDispatchOnMount(
    compose(
      handleSubscriptionTrackEvents,
      always({ lengthOfFreeTrial: LENGTH_OF_COUPON_FREE_TRIAL }),
    ),
  ),
)(UI);

export { UI };

export default CouponCampaignSuccess;
